import React, { useState, useEffect } from "react";
import Clock from "../../../utilities/Clock";
import Greeting from "../../../utilities/Greeting";
import FluidWrap from "./FluidWrap";
import TankContainer from "./TankContainer";
import WaterQualityWrap from "./WaterQualityWrap";
import GasWrap from "./GasWrap";
import DoSensorWrap from "./DoSensorWrap";
import Loading from "../../../utilities/Loading";
import axios from "../../../../utils/axios";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const UserAdminPanel = () => {
  const [levelDevices, setLevelDevices] = useState([]);
  const [waterQualityDevices, setWaterQualityDevices] = useState([]);
  const [gasDevices, setGasDevices] = useState([]);
  const [doSensorDevices, setDoSensorDevices] = useState([]);
  const [listDevices, setListDevices] = useState([]);
  const [expiredDevices, setExpiredDevices] = useState([]);
  const [openExpiryModal, setOpenExpiryModal] = useState(false);
  const navigate = useNavigate();

  const getList = async () => {
    try {
      const response = await axios.post("view/devices");

      // Get current date to check subscription status
      const currentDate = new Date();

      // Filter and find expired devices
      const expired = response?.data?.filter(
        (item) => new Date(item.subscription_end) <= currentDate
      );

      if (expired && expired.length > 0) {
        setExpiredDevices(expired);
        setOpenExpiryModal(true);
      }

      const flowDevices = response?.data
        ?.filter((item) => item.device_type === "flow")
        .map((item) => ({
          ...item,
          isExpired: new Date(item.subscription_end) <= currentDate,
        }));
      setListDevices(flowDevices);

      setLevelDevices(
        response?.data
          ?.filter((item) => item.device_type === "level" || item.device_type === "level_transmitter")
          .map((item) => ({
            ...item,
            isExpired: new Date(item.subscription_end) <= currentDate,
          }))
      );

      setWaterQualityDevices(
        response?.data
          ?.filter((item) => item.device_type === "water_quality")
          .map((item) => ({
            ...item,
            isExpired: new Date(item.subscription_end) <= currentDate,
          }))
      );

      setGasDevices(
        response?.data
          ?.filter((item) => item.device_type === "gas")
          .map((item) => ({
            ...item,
            isExpired: new Date(item.subscription_end) <= currentDate,
          }))
      );
      setDoSensorDevices(
        response?.data?.filter((item) => item.device_type === "do_sensor")
          .map((item) => ({ ...item, isExpired: new Date(item.subscription_end) <= currentDate })) || []
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handlePinClick = (index, pinned) => {
    const newItems = [...listDevices];
    const item = newItems.splice(index, 1)[0];
    item.pinned = pinned;
    item.isPinned = pinned;
    if (pinned) {
      newItems.unshift(item);
    } else {
      let i = 0;
      while (i < newItems.length && newItems[i].pinned) {
        i++;
      }
      newItems.splice(i, 0, item);
    }
    setListDevices(newItems);
    localStorage.setItem(item.id.toString(), pinned.toString());
  };

  const handleCloseExpiryModal = () => {
    setOpenExpiryModal(false);
  };

  const handleGoToPayment = () => {
    setOpenExpiryModal(false);
    navigate("/payment");
  };

  return (
    <div className="home-screen">
      <Loading />
      <div className="greeting-text">
        <Greeting />
        <Clock />
      </div>

      <h6 className="title">Active Devices</h6>
      <div>
        <div>
          <Box
            className="home-device-grid"
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 340px), 1fr))",
              gap: { xs: 2, sm: 3, md: 5 },
              width: "100%",
              minWidth: 0,
            }}
          >
            {Array.isArray(listDevices) &&
              listDevices?.map((item, index) => (
                <FluidWrap
                  key={index}
                  index={index}
                  pinned={item?.pinned}
                  onPinClick={() => handlePinClick(index, !item?.pinned)}
                  isPinned={item?.isPinned}
                  name={item?.alias_name}
                  deviceId={item?.id}
                  date={new Date(item?.subscription_end).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    }
                  )}
                  isExpired={item.isExpired}
                />
              ))}
            {levelDevices?.length > 0 &&
              levelDevices.map((item, index) => (
                <TankContainer
                  key={index}
                  index={index}
                  name={item.alias_name}
                  date={new Date(item.subscription_end).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    }
                  )}
                  deviceId={item.id}
                  isExpired={item.isExpired}
                  deviceType={item.device_type}
                  levelUnit={item.level_unit}
                  levelRangeMaxM={item.level_range_max_m}
                />
              ))}
            {waterQualityDevices?.length > 0 &&
              waterQualityDevices.map((item, index) => (
                <WaterQualityWrap
                  key={index}
                  index={index}
                  name={item.alias_name}
                  date={new Date(item.subscription_end).toLocaleDateString(
                    "en-US",
                    {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    }
                  )}
                  deviceId={item.id}
                  isExpired={item.isExpired}
                  pinned={item?.pinned}
                  onPinClick={() => {
                    const newItems = [...waterQualityDevices];
                    const deviceItem = newItems.splice(index, 1)[0];
                    deviceItem.pinned = !deviceItem.pinned;
                    deviceItem.isPinned = !deviceItem.pinned;
                    if (deviceItem.pinned) {
                      newItems.unshift(deviceItem);
                    } else {
                      let i = 0;
                      while (i < newItems.length && newItems[i].pinned) {
                        i++;
                      }
                      newItems.splice(i, 0, deviceItem);
                    }
                    setWaterQualityDevices(newItems);
                    localStorage.setItem(
                      deviceItem.id.toString(),
                      deviceItem.pinned.toString()
                    );
                  }}
                />
              ))}
            {gasDevices?.length > 0 &&
              gasDevices.map((item, index) => (
                <GasWrap
                  key={`gas-${item.id || index}`}
                  name={item.alias_name}
                  deviceId={item.id}
                  isExpired={item.isExpired}
                />
              ))}
            {doSensorDevices.map((item) => (
              <DoSensorWrap
                key={`do-${item.id}`}
                name={item.alias_name}
                deviceId={item.id}
                isExpired={item.isExpired}
              />
            ))}
          </Box>
        </div>
      </div>

      {/* Subscription Expiry Modal */}
      <Dialog
        open={openExpiryModal}
        onClose={handleCloseExpiryModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Subscription Alert"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {expiredDevices.length === 1 ? (
              <span>
                Your subscription for device{" "}
                <strong>{expiredDevices[0]?.alias_name}</strong> has expired.
                Please renew it to continue receiving data.
              </span>
            ) : (
              <>
                <span>
                  Your subscription has expired for the following devices:
                </span>
                <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
                  {expiredDevices.map((device, index) => (
                    <li key={index}>
                      <strong>{device.alias_name}</strong>
                    </li>
                  ))}
                </ul>
                <span>Please renew to continue receiving data.</span>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 2,
            pb: 2,
          }}
        >
          <Button onClick={handleCloseExpiryModal} color="primary">
            Dismiss
          </Button>
          <Button
            onClick={handleGoToPayment}
            color="primary"
            variant="contained"
            sx={{ ml: 2 }}
          >
            Go to Payment Page
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UserAdminPanel;
